import React from 'react';
import { useCrumbs } from '../breadcrumbs/useCrumbs';
import { useActiveSuite } from '../useActiveSuite';

export const MobilePageTitle: React.FC = () => {
  const crumbs = useCrumbs();
  const activeSuite = useActiveSuite();

  const title = crumbs.length > 0
    ? crumbs[crumbs.length - 1].label
    : activeSuite?.name || 'Helios Coach';

  return (
    <h1 className="font-bold text-sm text-navbar-foreground truncate max-w-[210px] leading-tight">
      {title}
    </h1>
  );
};

export default MobilePageTitle;
